// src/features/rooms/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import RoomsListPage from './pages/RoomsListPage';
import CreateRoomPage from './pages/CreateRoomPage';
import RoomDetailsPage from './pages/RoomDetailsPage';
import EditRoomPage from './pages/EditRoomPage';
import CreateEquipmentPage from '../equipment/pages/CreateEquipmentPage';
import EquipmentTemplateSelectionPage from '../equipment/pages/EquipmentTemplateSelectionPage';

export const RoomsRoutes = () => (
  <Route path="rooms">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="room:read">
          <RoomsListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="room:create">
          <CreateRoomPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":roomId"
      element={
        <ProtectedRoute requiredScope="room:read">
          <RoomDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":roomId/edit"
      element={
        <ProtectedRoute requiredScope="room:update">
          <EditRoomPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":roomId/equipment/select-template"
      element={
        <ProtectedRoute requiredScope="equipment:create">
          <EquipmentTemplateSelectionPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":roomId/equipment/create"
      element={
        <ProtectedRoute requiredScope="equipment:create">
          <CreateEquipmentPage />
        </ProtectedRoute>
      }
    />
  </Route>
);